const zh_hk = { 

    'hkidr.uploadconsent':'香港投資者識別碼制度及場外證券交易匯報制度表格*',
    'hkidr.donwloadconsent':'下載表格 (按此)',

    'hkidr.accountId':'帳戶號碼',
    'hkidr.idDoc':'您的身份證明文件',
    'hkidr.idNo': '您的身份證明文件號碼',
    'hkidr.accountName':'帳戶名稱 (英文)',
    'hkidr.hkidr':'香港投資者識別碼資料',
    'hkidr.docType':'身分證明文件',
    'hkidr.doc':'上載文件',
    'hkidr.HKID':'香港身份證',    
    'hkidr.PP':'護照',
    'hkidr.CONSENT':'香港投資者識別碼制度及場外證券交易匯報制度表格',
    'hkidr.NTID':'國民身份證',
    'hkidr.NTIDF':'上載文件(正面)',
    'hkidr.NTIDB':'上載文件(背面)',  
    'hkidr.OTH':'其他',
    'hkidr.':' ',
    'hkidr.accountNo': '帳戶號碼',
    'hkidr.accName': '帳戶名稱',
    'hkidr.invalidIssuePlace':'簽發地點無效',
    'hkidr.uploadFileNotice': '本人/吾等需要更新客戶識別信息，並向凱基亞洲提供最新的身分證明文件副本(如適用)',
    'hkidr.jointAccUploadFileNotice': '請選擇身分證明文件及檔案後按〝添加〞鍵。如多於一個檔案須提交，請重複此步驟。',
    'hkidr.invalidDocType':'身分證明文件無效',
    'hkidr.invalidFile':'檔案無效',
    'hkidr.invalidAcc':'帳戶號碼無效',
    'hkidr.invalidConsent':'確認無效',
    'hkidr.invalideSignature':'電子簽署無效',
    'hkidr.browse':'瀏覽',
    'hkidr.add':'添加',
    "hkidr.concentdesp": "我/我們同意及接受以下條款:",
    "hkidr.tc": "條款 12345678",
    'general.notes': '註',
    'general.submit': '提交',
    'hkidr.captcha':'驗證碼',
    'general.formAuth':'KGI eForm Auth',
    'hkidr.idIssuePlace': '簽發地點',
    'hkidr.remark1':'客戶必須於客戶同意書及身分證明文件副本(如適用)上簽署，否則我們可能會不接受閣下的指示。',
    'hkidr.remark2':'在本表格上載客戶的身分證明文件，會一併用於更新您的帳戶資料。',
    'hkidr.remark3':'項目標有*號者必需填寫，否則我們可能會不接受閣下的指示。',
    'hkidr.remark4':'請於香港工作天下午四時正前提交本表格。在工作天截止時間後或是在星期六、日及公眾假期遞交的客戶指示將在隨後的一個工作天辦理。',
    'hkidr.eSignature':"電子簽署",
    'hkidr.requestUpdate':"更新身分證明文件",
    'hkidr.yes':"是",
    'hkidr.no':"否",
    'general.confirmation':'確認',
    'general.cancel':'取消',
    'general.ok':'提交',
    'general.close':'關閉',
    'hkidr.fileinstruction':'請於上載客戶的身分證明文件副本(正面)前於該副本下方簽名。',
    'hkidr.sample':'樣本',
    'hkidr.result':'結果',
    'hkidr.success':'提交成功',
    'hkidr.fail':'提交失敗. 請重新輸入或聯絡您的營業代表。',
    'hkidr.LEI':'法律實體識別編碼(LEI)登記文件',
    'hkidr.COI':'公司註冊證明書',
    'hkidr.BRC':'商業登記證',
    'hkidr.OTHS':'其他同等文件',
    'hkidr.maxexceed': '已達上載文件上限',
    'hkidr.verifyErr_1':' ',
    'hkidr.verifyErr_0':' ',
    'hkidr.verifyErr_-1':'驗證碼無效',
    'hkidr.verifyErr_-2':'請輸入正確的帳戶號碼及帳戶名稱(英文)',
    'hkidr.verifyErr_-3':'請輸入正確的帳戶號碼及帳戶名稱(英文)',
    'hkidr.verifyErr_-4':'驗證失敗 ,請聯絡您的營業代表。',
    'hkidr.consented':'感謝使用凱基電子服務,您的資料已提交。',
    'hkidr.invalidFileType':'檔案無效: 只支援檔案類型 jpg/gif/png/pdf',
    'hkidr.invalidFileSize':'檔案無效: 檔案大小超過10MB',
};
export default zh_hk;